// TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.

import invariant from 'invariant';
import PropTypes from 'prop-types';
import { ModalBsSizeE } from '../modal.types';

export const SIZE_MAP = {
  [ModalBsSizeE.large]: 'lg',
  [ModalBsSizeE.medium]: 'md',
  [ModalBsSizeE.small]: 'sm',
  [ModalBsSizeE.xsmall]: 'xs',
  [ModalBsSizeE.lg]: 'lg',
  [ModalBsSizeE.md]: 'md',
  [ModalBsSizeE.sm]: 'sm',
  [ModalBsSizeE.xs]: 'xs'
};

export function prefix(props, variant) {
  let bsClass = (props.bsClass || '').trim();
  invariant(bsClass != null, 'A `bsClass` prop is required for this component');
  return bsClass + (variant ? `-${variant}` : '');
}

export const getSizeClass = (bsClass, bsSize) => {
  return `${bsClass}-${(SIZE_MAP[bsSize] || bsSize)}`;
};
